import store from 'store';
import { getStorePrefix } from './config';

store._namespacePrefix = getStorePrefix();

export const set = function (key, value) {
  store.set(key, value);
};

export const get = function (key) {
  return store.get(key);
};

export const remove = function (key) {
  store.remove(key);
};

export const each = function (callback) {
  store.each(callback);
};

export const clearAll = function () {
  store.clearAll();
};

export const enabled = function () {
  return store.enabled;
};
